@if (!homeworkService.isHomeworkEditorOpened() && !homeworkService.testGeneratorOpened) {
    <app-homework-tip>
    </app-homework-tip>
}
@if (!homeworkService.isHomeworkEditorOpened() && !homeworkService.testGeneratorOpened) {
    <sidebar-portfolio>
    </sidebar-portfolio>
}
<sidebar-test-generator [class.hidden]="homeworkService.isHomeworkEditorOpened()"></sidebar-test-generator>
@if (homeworkService.showHomeworkButton) {
    <sidebar-homework [class.hidden]="homeworkService.testGeneratorOpened"></sidebar-homework>
}
